export const ANALYTICS_EVENT_TYPES = {
  LOGIN: 'login',
  LICENSE_ACTIVATED: 'license-activated',
  MODULE_ACCESSED: 'module-accessed',
  VIRTUAL_EXERCISE_MODULE_ACCESSED: 'virtual-exercise-module-accessed',
  NODE_ACCESSED: 'node-accessed',
  MEDIALINK_ACCESSED: 'medialink-accessed',
  APP_ACCESSED: 'app-accessed',
  DIGIBOOK_ACCESSED: 'digibook-accessed',
  DIGIBOOK_PAGE_ACCESSED: 'digibook-page-accessed',
  USER_MATERIAL_CREATED: 'user-material-created',
  USER_MATERIAL_ACCESSED: 'user-material-accessed',
  USER_WHITEPAGE_ACCESSED: 'user-whitepage-accessed',
  SLIDE_SET_CREATED: 'slide-set-created',
  SLIDE_SET_ACCESSED: 'slide-set-accessed',
  SLIDE_SET_VIEWER_ACCESSED: 'slide-set-viewer-accessed',
  SLIDE_SET_OVERVIEW_ACCESSED: 'slide-set-overview-accessed',
  SLIDE_SET_EDIT_MODE_ACCESSED: 'slide-set-edit-mode-accessed',
  SLIDE_SET_DUPLICATED: 'slide-set-duplicated',
  SLIDE_SET_DELETED: 'slide-set-deleted',
} as const;

export const ANALYTICS_EVENT_LOCATIONS = {
  PORTAAL: 'portaal',
} as const;

export const ANALYTICS_EVENT_SUBLOCATIONS = {
  PORTAAL_MATERIAL: 'portaal-material',
  PORTAAL_MATERIAL_APPS: 'portaal-material-apps',
  PORTAAL_EXERCISE: 'portaal-exercise',
  PORTAAL_EXERCISE_BOOK: 'portaal-exercise-book',
  PORTAAL_EXERCISE_THEME: 'portaal-exercise-theme',
  PORTAAL_DASHBOARD: 'portaal-dashboard',
  PORTAAL_MODULE_DASHBOARD: 'portaal-module-dashboard',
  PORTAAL_SEARCH: 'portaal-search',
  PORTAAL_BOOK_SWITCHER: 'portaal-book-switcher',
  PORTAAL_CATALOG: 'portaal-catalog',
  PORTAAL_MY_ASSIGNMENTS: 'portaal-my-assignments',
  PORTAAL_MODULE_ASSIGNMENTS: 'portaal-module-assignments',
  PORTAAL_TEACHER_ASSIGNMENTS: 'portaal-teacher-assignments',
  PORTAAL_RESULTS: 'portaal-results',
  PORTAAL_SUBMODULE_SELECTION: 'portaal-submodule-selection',
  PORTAAL_PINNED_MATERIAL: 'portaal-pinned-material',
} as const;
